<template>
  <family-page-wrapper class="family-ride-ordering">
    <div class="row">
      <div class="col-sm-6 col-12">
        <cancel-ride v-if="hasActiveRide" />
        <cancel-auto-retry-ride v-if="isAutoRetryGettingEstimate" />

        <div
          v-if="isMembershipSuspended"
          class="suspended-error-message"
        >
          <span>Your membership was suspended.</span>
          <br>
          <span>Please give support team a call at 1-855-464-6872 before ordering or scheduling a ride.</span>
        </div>
        <template v-else>
          <el-radio-group v-model="rideFormType">
            <el-radio-button label="order">
              Order a Ride Now
            </el-radio-button>
            <el-radio-button label="schedule">
              Schedule a Ride in the Future
            </el-radio-button>
          </el-radio-group>

          <basic-ride-limit-value-upgrade-banner class="mt-3 mb-3" />

          <family-order-ride
            v-if="rideFormType === 'order'"
            :has-completed-ride="hasCompletedRide"
          />
          <family-schedule-ride
            v-if="rideFormType === 'schedule'"
            :has-completed-ride="hasCompletedRide"
          />
        </template>
      </div>

      <div class="col-sm-6 col-12">
        <call-us />
      </div>
    </div>
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { ref, toRefs, defineAsyncComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { ElLoading } from 'element-plus';

import { useCustomer } from '@/use/customer';
import { sendGet } from '@/Utils/api';

const CancelRide = defineAsyncComponent(() => import('@/components/Main/Operator/RideOrdering/CancelRide.vue') as any);

const CancelAutoRetryRide = defineAsyncComponent(() => import('@/components/Main/Operator/RideOrdering/CancelAutoRetryRide.vue') as any);

const FamilyOrderRide = defineAsyncComponent(() => import('@/components/Main/Shared/OrderRide/OrderRide.vue') as any);

const FamilyScheduleRide = defineAsyncComponent(() => import('@/components/Main/Shared/OrderRide/ScheduleRide.vue') as any);

const BasicRideLimitValueUpgradeBanner = defineAsyncComponent(
  () => import('@/components/Main/Operator/RideOrdering/BasicRideLimitValueUpgradeBanner.vue') as any,
);

const CallUs = defineAsyncComponent(() => import('./CallUs.vue') as any);

const route = useRoute();

const { customerStatus, customerInfo } = useCustomer();
const { isMembershipSuspended, hasActiveRide, isAutoRetryGettingEstimate } = toRefs(customerStatus);

const rideFormType = ref((route.query.rideFormType as string) || 'schedule');
const hasCompletedRide = ref(false);

const loadRideInfo = async () => {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading Ride History...',
    background: 'rgba(0, 0, 0, 0.7)',
    customClass: 'custom-full-spinner-class',
  });

  try {
    const response = await sendGet('rides', {
      callerId: customerInfo.value.id,
      limit: 1,
      offset: 0,
    });

    hasCompletedRide.value = response.data.count > 0;
  } catch (err) {
    // No need to do anything
  } finally {
    loading.close();
  }
}

onMounted(loadRideInfo)
</script>

<style lang="scss">
.family-ride-ordering {
  .el-radio-group {
    display: flex;

    .el-radio-button {
      flex: 1;

      .el-radio-button__inner {
        width: 100%;
      }
    }
  }

  .suspended-error-message {
    font-size: 16px;
    color: #f00;
  }
}
</style>
